import { useEffect, useMemo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { INITIAL_DOR } from '../data/settings';
import { getDiffBetweenNestedObj } from '../../../utils/helpers';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getDorIntegration } from '../../../store/settings/selectors';

export function useEditDorIntegration() {
  const [formInputs, setFormInputs] = useState(INITIAL_DOR);
  const [prevFormInputs, setPrevFormInputs] = useState(INITIAL_DOR);
  const dorIntegration = useAppSelector(getDorIntegration);
  const [mode, setMode] = useState('create');

  useEffect(() => {
    if (dorIntegration?.apiKey) {
      const integration = {
        apiKey: dorIntegration.apiKey,
        teamId: dorIntegration.teamId,
      };

      setFormInputs(integration);
    } else {
      setMode('create');
      setFormInputs(INITIAL_DOR);
      setPrevFormInputs(INITIAL_DOR);
    }
  }, [dorIntegration]);

  const isEdited = useMemo(() => {
    const diff = getDiffBetweenNestedObj(formInputs, prevFormInputs);

    return !isEmpty(diff);
  }, [formInputs, prevFormInputs]);

  return {
    mode,
    formInputs,
    isEdited,
    setFormInputs,
  };
}
